// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"760":"dedc201c","922":"dec5fd7e"}[chunkId] + ".chunk.css";
};